import React, { useEffect } from 'react'
import { useTranslation } from "react-i18next";
import i18n, { _get_i18Lang } from '../../i18n';
import TermsOfUseService from "../../Services/OnePageServices";
import { Typography, Box } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { HeaderBox } from './MobileBookPage';
import Loader from '../Loader';
import logoMain from "../../Images/logo_Main.png";

const MobileTermsOfUse = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [loading, setLoading] = React.useState(false);
    const [terms, setTerms] = React.useState({
        __html: "",
    });

    function createMarkup() {
        return {
            __html: terms?.__html
        };
    }

    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const response = await TermsOfUseService.getTermsOfUseData(_get_i18Lang());
                const result = await response;
                if (result?.status) {
                    setTerms({ __html: result.result.content });
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [i18n.language]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Box sx={{
            height: '100vh',
            background: 'linear-gradient(to right, #f97316 0%, #fdba74 3%, #ffffff 5%, #ffffff 95%, #fdba74 97%, #f97316 100%)',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }}>
            {/* Fixed Top Section - Header + Logo */}
            <Box sx={{ flexShrink: 0 }}>
                <HeaderBox>
                    <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                        <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                    </IconButton>
                    <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                        <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                    </IconButton>
                    <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                        {t("shrihari_tr")}
                    </Typography>
                    <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                        {t("Terms_of_Use_tr")}
                    </Typography>
                </HeaderBox>

                {/* Logo centered */}
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    pb: 2
                }}>
                    <Box
                        component="img"
                        src={logoMain}
                        alt="Gita Seva"
                        sx={{
                            width: '15vw',
                            height: '15vw',
                            maxWidth: '80px',
                            maxHeight: '80px'
                        }}
                    />
                </Box>
            </Box>

            {/* Scrollable Content Section */}
            <Box sx={{
                flex: 1,
                mx: 4,
                mb: 2,
                backgroundColor: 'rgba(255,255,255,0.85)',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                overflow: 'auto',
                p: 2,
                '&::-webkit-scrollbar': {
                    width: '6px'
                },
                '&::-webkit-scrollbar-track': {
                    background: 'transparent'
                },
                '&::-webkit-scrollbar-thumb': {
                    background: 'white',
                    borderRadius: '3px',
                    minHeight: '20px',
                    maxHeight: '30px'
                }
            }}>
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                        <Loader loading={loading} />
                    </Box>
                ) : terms && terms.__html.length > 0 ? (
                    <div
                        className='html-content'
                        style={{ fontSize: "14px", lineHeight: 1.6 }}
                        dangerouslySetInnerHTML={createMarkup()}
                    ></div>
                ) : (
                    <Typography sx={{ textAlign: 'center', mt: 4, color: 'text.secondary' }}>
                        {t("result_not_found_tr")}
                    </Typography>
                )}
            </Box>
        </Box>
    )
}

export default MobileTermsOfUse
